<template>
  <div class="tw-mt-2" :class="alignWithText ? '-tw-ml-1' : ''">
    <WdsButtonGhost type="button" @click="toggleShowMore">
      <span class="tw-flex tw-items-center">
        {{ buttonText }}
        <WdsIcon class="tw-ml-2" :class="chevronClass" name="chevron-down" :size="16" />
      </span>
    </WdsButtonGhost>
  </div>
</template>

<script>
import { WdsButtonGhost, WdsIcon } from '@worksome/wds-components'

export default {
  name: 'BaseShowMoreButton',
  components: { WdsButtonGhost, WdsIcon },
  props: {
    buttonText: {
      type: String,
      default: $t('Show more'),
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    // Often when using BaseShowMore, the button text should be aligned with text content above and use a negative
    // left margin to account for padding within WdsButtonGhost. This prop provides a quick way to left align.
    alignWithText: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      chevronClass: 'chevron-down',
    }
  },
  methods: {
    toggleShowMore() {
      this.chevronClass = this.chevronClass === 'chevron-down' ? 'chevron-up' : 'chevron-down'
    },
  },
}
</script>

<style lang="scss" scoped>
.chevron-down {
  transform: rotate(0deg);
  transition: transform 200ms linear;
}

.chevron-up {
  transform: rotate(180deg);
  transition: transform 200ms linear;
}
</style>
